var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({},'a',{href:_vm.url},false),[_vm._v("授权")])}
var staticRenderFns = []

export { render, staticRenderFns }